// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/title-bars/title-bars.less
// module id = 3687
// module chunks = 0